// Minimal browser stub for node:url.
// Only fileURLToPath is needed; it is called inside a try/catch in
// @nowline/export-core/fonts/bundled.js so an imprecise result is fine.
export const fileURLToPath = (url: string | URL) => String(url ?? '');
export default { fileURLToPath };
